import { AddressPool } from '../../hooks';

export const getAllAddresses = (pool: AddressPool) => {
  // Validate and parse IP addresses using a simpler approach
  const startParts = pool.start_ip.split('.');
  const endParts = pool.end_ip.split('.');

  // Validate IP format
  if (startParts.length !== 4 || endParts.length !== 4) {
    throw new Error('Invalid IP address format');
  }

  // Parse octets and validate they are valid numbers 0-255
  const startOctets = startParts.map((part) => {
    const num = parseInt(part, 10);
    if (isNaN(num) || num < 0 || num > 255) {
      throw new Error('Invalid IP address format');
    }
    return num;
  });

  const endOctets = endParts.map((part) => {
    const num = parseInt(part, 10);
    if (isNaN(num) || num < 0 || num > 255) {
      throw new Error('Invalid IP address format');
    }
    return num;
  });

  // Ensure first two octets match (same /16 network)
  if (startOctets[0] !== endOctets[0] || startOctets[1] !== endOctets[1]) {
    throw new Error('Start and end IPs must be in the same /16 network');
  }

  // Calculate numeric values for comparison (only last 2 octets)
  const startValue = (startOctets[2] << 8) + startOctets[3];
  const endValue = (endOctets[2] << 8) + endOctets[3];

  if (startValue > endValue) {
    throw new Error(
      'Start IP address must be less than or equal to end IP address',
    );
  }

  const addresses = [];
  const baseNetwork = `${startOctets[0]}.${startOctets[1]}`;

  // Generate all addresses
  for (let third = startOctets[2]; third <= endOctets[2]; third++) {
    const fourthStart = third === startOctets[2] ? startOctets[3] : 0;
    const fourthEnd = third === endOctets[2] ? endOctets[3] : 255;

    for (let fourth = fourthStart; fourth <= fourthEnd; fourth++) {
      addresses.push(`${baseNetwork}.${third}.${fourth}`);
    }
  }

  return addresses;
};
